import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

// The sample player never mounts ordinary routes, auth bootstrap or analytics.
const App = React.lazy(() => process.env.REACT_APP_ENVIRONMENT === 'staging' && process.env.REACT_APP_THEME_STUDIO_DEMO === 'true'
  ? import('./themeStudioDemo/ThemeStudioDemoApp')
  : import('./App'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<p role="status">Loading Wise Friend…</p>}>
      <App />
    </React.Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
